import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d6aaf306 = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _031688f3 = () => interopDefault(import('../../../pages/campaigns/index.vue' /* webpackChunkName: "pages/campaigns/index" */))
const _739390df = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _98b9de18 = () => interopDefault(import('../../../pages/creatives/index.vue' /* webpackChunkName: "pages/creatives/index" */))
const _3d3b33f6 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _6859ff4f = () => interopDefault(import('../../../pages/manageAudience/index.vue' /* webpackChunkName: "pages/manageAudience/index" */))
const _74d267f6 = () => interopDefault(import('../../../pages/manageEvent/index.vue' /* webpackChunkName: "pages/manageEvent/index" */))
const _ccf0c846 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _2d674442 = () => interopDefault(import('../../../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _10f67f8f = () => interopDefault(import('../../../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _92f5904a = () => interopDefault(import('../../../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _16336eb6 = () => interopDefault(import('../../../pages/version.vue' /* webpackChunkName: "pages/version" */))
const _050afa4d = () => interopDefault(import('../../../pages/account/add-funds.vue' /* webpackChunkName: "pages/account/add-funds" */))
const _13773b6d = () => interopDefault(import('../../../pages/account/attribution-setting.vue' /* webpackChunkName: "pages/account/attribution-setting" */))
const _152749ba = () => interopDefault(import('../../../pages/account/billing-management.vue' /* webpackChunkName: "pages/account/billing-management" */))
const _a9b041fa = () => interopDefault(import('../../../pages/account/change-password.vue' /* webpackChunkName: "pages/account/change-password" */))
const _60761484 = () => interopDefault(import('../../../pages/account/complete-account.vue' /* webpackChunkName: "pages/account/complete-account" */))
const _27a3d2ee = () => interopDefault(import('../../../pages/account/operation-log.vue' /* webpackChunkName: "pages/account/operation-log" */))
const _7e86ee84 = () => interopDefault(import('../../../pages/account/reset-password.vue' /* webpackChunkName: "pages/account/reset-password" */))
const _32be97ca = () => interopDefault(import('../../../pages/account/target-app.vue' /* webpackChunkName: "pages/account/target-app" */))
const _84456820 = () => interopDefault(import('../../../pages/account/user-management.vue' /* webpackChunkName: "pages/account/user-management" */))
const _39c43134 = () => interopDefault(import('../../../pages/account/wechat-pay.vue' /* webpackChunkName: "pages/account/wechat-pay" */))
const _f1223faa = () => interopDefault(import('../../../pages/campaigns/create.vue' /* webpackChunkName: "pages/campaigns/create" */))
const _757c2b68 = () => interopDefault(import('../../../pages/common/payment/index.vue' /* webpackChunkName: "pages/common/payment/index" */))
const _d0768f86 = () => interopDefault(import('../../../pages/files/preview.vue' /* webpackChunkName: "pages/files/preview" */))
const _8fc81cae = () => interopDefault(import('../../../pages/manageAudience/index-old.vue' /* webpackChunkName: "pages/manageAudience/index-old" */))
const _b0b852dc = () => interopDefault(import('../../../pages/manageEvent/copy.vue' /* webpackChunkName: "pages/manageEvent/copy" */))
const _092d2c40 = () => interopDefault(import('../../../pages/manageEvent/indexV1.vue' /* webpackChunkName: "pages/manageEvent/indexV1" */))
const _7cedabba = () => interopDefault(import('../../../pages/offers/copy.vue' /* webpackChunkName: "pages/offers/copy" */))
const _81bfaafe = () => interopDefault(import('../../../pages/offers/create.vue' /* webpackChunkName: "pages/offers/create" */))
const _2fbeef56 = () => interopDefault(import('../../../pages/offers/detail.vue' /* webpackChunkName: "pages/offers/detail" */))
const _0ad9d062 = () => interopDefault(import('../../../pages/offers/edit.vue' /* webpackChunkName: "pages/offers/edit" */))
const _66a64487 = () => interopDefault(import('../../../pages/offers/set-tracking.vue' /* webpackChunkName: "pages/offers/set-tracking" */))
const _db3638f0 = () => interopDefault(import('../../../pages/reports/cohort.vue' /* webpackChunkName: "pages/reports/cohort" */))
const _56790782 = () => interopDefault(import('../../../pages/reports/creative.vue' /* webpackChunkName: "pages/reports/creative" */))
const _26ca30cd = () => interopDefault(import('../../../pages/reports/dco.vue' /* webpackChunkName: "pages/reports/dco" */))
const _42f7a557 = () => interopDefault(import('../../../pages/reports/event.vue' /* webpackChunkName: "pages/reports/event" */))
const _38c32f43 = () => interopDefault(import('../../../pages/reports/pixel.vue' /* webpackChunkName: "pages/reports/pixel" */))
const _5b60b6d8 = () => interopDefault(import('../../../pages/reports/skan.vue' /* webpackChunkName: "pages/reports/skan" */))
const _41674ee5 = () => interopDefault(import('../../../pages/settings/mediaPostback/index.vue' /* webpackChunkName: "pages/settings/mediaPostback/index" */))
const _1336d879 = () => interopDefault(import('../../../pages/settings/mediaPostback/create.vue' /* webpackChunkName: "pages/settings/mediaPostback/create" */))
const _84263872 = () => interopDefault(import('../../../pages/settings/mediaPostback/edit.vue' /* webpackChunkName: "pages/settings/mediaPostback/edit" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _d6aaf306,
    name: "account___en___default"
  }, {
    path: "/campaigns",
    component: _031688f3,
    name: "campaigns___en___default"
  }, {
    path: "/cn",
    component: _739390df,
    name: "index___cn"
  }, {
    path: "/creatives",
    component: _98b9de18,
    name: "creatives___en___default"
  }, {
    path: "/en",
    component: _739390df,
    name: "index___en"
  }, {
    path: "/ja",
    component: _739390df,
    name: "index___ja"
  }, {
    path: "/login",
    component: _3d3b33f6,
    name: "login___en___default"
  }, {
    path: "/manageAudience",
    component: _6859ff4f,
    name: "manageAudience___en___default"
  }, {
    path: "/manageEvent",
    component: _74d267f6,
    name: "manageEvent___en___default"
  }, {
    path: "/offers",
    component: _ccf0c846,
    name: "offers___en___default"
  }, {
    path: "/redirect",
    component: _2d674442,
    name: "redirect___en___default"
  }, {
    path: "/reports",
    component: _10f67f8f,
    name: "reports___en___default"
  }, {
    path: "/signup",
    component: _92f5904a,
    name: "signup___en___default"
  }, {
    path: "/version",
    component: _16336eb6,
    name: "version___en___default"
  }, {
    path: "/account/add-funds",
    component: _050afa4d,
    name: "account-add-funds___en___default"
  }, {
    path: "/account/attribution-setting",
    component: _13773b6d,
    name: "account-attribution-setting___en___default"
  }, {
    path: "/account/billing-management",
    component: _152749ba,
    name: "account-billing-management___en___default"
  }, {
    path: "/account/change-password",
    component: _a9b041fa,
    name: "account-change-password___en___default"
  }, {
    path: "/account/complete-account",
    component: _60761484,
    name: "account-complete-account___en___default"
  }, {
    path: "/account/operation-log",
    component: _27a3d2ee,
    name: "account-operation-log___en___default"
  }, {
    path: "/account/reset-password",
    component: _7e86ee84,
    name: "account-reset-password___en___default"
  }, {
    path: "/account/target-app",
    component: _32be97ca,
    name: "account-target-app___en___default"
  }, {
    path: "/account/user-management",
    component: _84456820,
    name: "account-user-management___en___default"
  }, {
    path: "/account/wechat-pay",
    component: _39c43134,
    name: "account-wechat-pay___en___default"
  }, {
    path: "/campaigns/create",
    component: _f1223faa,
    name: "campaigns-create___en___default"
  }, {
    path: "/cn/account",
    component: _d6aaf306,
    name: "account___cn"
  }, {
    path: "/cn/campaigns",
    component: _031688f3,
    name: "campaigns___cn"
  }, {
    path: "/cn/creatives",
    component: _98b9de18,
    name: "creatives___cn"
  }, {
    path: "/cn/login",
    component: _3d3b33f6,
    name: "login___cn"
  }, {
    path: "/cn/manageAudience",
    component: _6859ff4f,
    name: "manageAudience___cn"
  }, {
    path: "/cn/manageEvent",
    component: _74d267f6,
    name: "manageEvent___cn"
  }, {
    path: "/cn/offers",
    component: _ccf0c846,
    name: "offers___cn"
  }, {
    path: "/cn/redirect",
    component: _2d674442,
    name: "redirect___cn"
  }, {
    path: "/cn/reports",
    component: _10f67f8f,
    name: "reports___cn"
  }, {
    path: "/cn/signup",
    component: _92f5904a,
    name: "signup___cn"
  }, {
    path: "/cn/version",
    component: _16336eb6,
    name: "version___cn"
  }, {
    path: "/common/payment",
    component: _757c2b68,
    name: "common-payment___en___default"
  }, {
    path: "/en/account",
    component: _d6aaf306,
    name: "account___en"
  }, {
    path: "/en/campaigns",
    component: _031688f3,
    name: "campaigns___en"
  }, {
    path: "/en/creatives",
    component: _98b9de18,
    name: "creatives___en"
  }, {
    path: "/en/login",
    component: _3d3b33f6,
    name: "login___en"
  }, {
    path: "/en/manageAudience",
    component: _6859ff4f,
    name: "manageAudience___en"
  }, {
    path: "/en/manageEvent",
    component: _74d267f6,
    name: "manageEvent___en"
  }, {
    path: "/en/offers",
    component: _ccf0c846,
    name: "offers___en"
  }, {
    path: "/en/redirect",
    component: _2d674442,
    name: "redirect___en"
  }, {
    path: "/en/reports",
    component: _10f67f8f,
    name: "reports___en"
  }, {
    path: "/en/signup",
    component: _92f5904a,
    name: "signup___en"
  }, {
    path: "/en/version",
    component: _16336eb6,
    name: "version___en"
  }, {
    path: "/files/preview",
    component: _d0768f86,
    name: "files-preview___en___default"
  }, {
    path: "/ja/account",
    component: _d6aaf306,
    name: "account___ja"
  }, {
    path: "/ja/campaigns",
    component: _031688f3,
    name: "campaigns___ja"
  }, {
    path: "/ja/creatives",
    component: _98b9de18,
    name: "creatives___ja"
  }, {
    path: "/ja/login",
    component: _3d3b33f6,
    name: "login___ja"
  }, {
    path: "/ja/manageAudience",
    component: _6859ff4f,
    name: "manageAudience___ja"
  }, {
    path: "/ja/manageEvent",
    component: _74d267f6,
    name: "manageEvent___ja"
  }, {
    path: "/ja/offers",
    component: _ccf0c846,
    name: "offers___ja"
  }, {
    path: "/ja/redirect",
    component: _2d674442,
    name: "redirect___ja"
  }, {
    path: "/ja/reports",
    component: _10f67f8f,
    name: "reports___ja"
  }, {
    path: "/ja/signup",
    component: _92f5904a,
    name: "signup___ja"
  }, {
    path: "/ja/version",
    component: _16336eb6,
    name: "version___ja"
  }, {
    path: "/manageAudience/index-old",
    component: _8fc81cae,
    name: "manageAudience-index-old___en___default"
  }, {
    path: "/manageEvent/copy",
    component: _b0b852dc,
    name: "manageEvent-copy___en___default"
  }, {
    path: "/manageEvent/indexV1",
    component: _092d2c40,
    name: "manageEvent-indexV1___en___default"
  }, {
    path: "/offers/copy",
    component: _7cedabba,
    name: "offers-copy___en___default"
  }, {
    path: "/offers/create",
    component: _81bfaafe,
    name: "offers-create___en___default"
  }, {
    path: "/offers/detail",
    component: _2fbeef56,
    name: "offers-detail___en___default"
  }, {
    path: "/offers/edit",
    component: _0ad9d062,
    name: "offers-edit___en___default"
  }, {
    path: "/offers/set-tracking",
    component: _66a64487,
    name: "offers-set-tracking___en___default"
  }, {
    path: "/reports/cohort",
    component: _db3638f0,
    name: "reports-cohort___en___default"
  }, {
    path: "/reports/creative",
    component: _56790782,
    name: "reports-creative___en___default"
  }, {
    path: "/reports/dco",
    component: _26ca30cd,
    name: "reports-dco___en___default"
  }, {
    path: "/reports/event",
    component: _42f7a557,
    name: "reports-event___en___default"
  }, {
    path: "/reports/pixel",
    component: _38c32f43,
    name: "reports-pixel___en___default"
  }, {
    path: "/reports/skan",
    component: _5b60b6d8,
    name: "reports-skan___en___default"
  }, {
    path: "/settings/mediaPostback",
    component: _41674ee5,
    name: "settings-mediaPostback___en___default"
  }, {
    path: "/cn/account/add-funds",
    component: _050afa4d,
    name: "account-add-funds___cn"
  }, {
    path: "/cn/account/attribution-setting",
    component: _13773b6d,
    name: "account-attribution-setting___cn"
  }, {
    path: "/cn/account/billing-management",
    component: _152749ba,
    name: "account-billing-management___cn"
  }, {
    path: "/cn/account/change-password",
    component: _a9b041fa,
    name: "account-change-password___cn"
  }, {
    path: "/cn/account/complete-account",
    component: _60761484,
    name: "account-complete-account___cn"
  }, {
    path: "/cn/account/operation-log",
    component: _27a3d2ee,
    name: "account-operation-log___cn"
  }, {
    path: "/cn/account/reset-password",
    component: _7e86ee84,
    name: "account-reset-password___cn"
  }, {
    path: "/cn/account/target-app",
    component: _32be97ca,
    name: "account-target-app___cn"
  }, {
    path: "/cn/account/user-management",
    component: _84456820,
    name: "account-user-management___cn"
  }, {
    path: "/cn/account/wechat-pay",
    component: _39c43134,
    name: "account-wechat-pay___cn"
  }, {
    path: "/cn/campaigns/create",
    component: _f1223faa,
    name: "campaigns-create___cn"
  }, {
    path: "/cn/common/payment",
    component: _757c2b68,
    name: "common-payment___cn"
  }, {
    path: "/cn/files/preview",
    component: _d0768f86,
    name: "files-preview___cn"
  }, {
    path: "/cn/manageAudience/index-old",
    component: _8fc81cae,
    name: "manageAudience-index-old___cn"
  }, {
    path: "/cn/manageEvent/copy",
    component: _b0b852dc,
    name: "manageEvent-copy___cn"
  }, {
    path: "/cn/manageEvent/indexV1",
    component: _092d2c40,
    name: "manageEvent-indexV1___cn"
  }, {
    path: "/cn/offers/copy",
    component: _7cedabba,
    name: "offers-copy___cn"
  }, {
    path: "/cn/offers/create",
    component: _81bfaafe,
    name: "offers-create___cn"
  }, {
    path: "/cn/offers/detail",
    component: _2fbeef56,
    name: "offers-detail___cn"
  }, {
    path: "/cn/offers/edit",
    component: _0ad9d062,
    name: "offers-edit___cn"
  }, {
    path: "/cn/offers/set-tracking",
    component: _66a64487,
    name: "offers-set-tracking___cn"
  }, {
    path: "/cn/reports/cohort",
    component: _db3638f0,
    name: "reports-cohort___cn"
  }, {
    path: "/cn/reports/creative",
    component: _56790782,
    name: "reports-creative___cn"
  }, {
    path: "/cn/reports/dco",
    component: _26ca30cd,
    name: "reports-dco___cn"
  }, {
    path: "/cn/reports/event",
    component: _42f7a557,
    name: "reports-event___cn"
  }, {
    path: "/cn/reports/pixel",
    component: _38c32f43,
    name: "reports-pixel___cn"
  }, {
    path: "/cn/reports/skan",
    component: _5b60b6d8,
    name: "reports-skan___cn"
  }, {
    path: "/cn/settings/mediaPostback",
    component: _41674ee5,
    name: "settings-mediaPostback___cn"
  }, {
    path: "/en/account/add-funds",
    component: _050afa4d,
    name: "account-add-funds___en"
  }, {
    path: "/en/account/attribution-setting",
    component: _13773b6d,
    name: "account-attribution-setting___en"
  }, {
    path: "/en/account/billing-management",
    component: _152749ba,
    name: "account-billing-management___en"
  }, {
    path: "/en/account/change-password",
    component: _a9b041fa,
    name: "account-change-password___en"
  }, {
    path: "/en/account/complete-account",
    component: _60761484,
    name: "account-complete-account___en"
  }, {
    path: "/en/account/operation-log",
    component: _27a3d2ee,
    name: "account-operation-log___en"
  }, {
    path: "/en/account/reset-password",
    component: _7e86ee84,
    name: "account-reset-password___en"
  }, {
    path: "/en/account/target-app",
    component: _32be97ca,
    name: "account-target-app___en"
  }, {
    path: "/en/account/user-management",
    component: _84456820,
    name: "account-user-management___en"
  }, {
    path: "/en/account/wechat-pay",
    component: _39c43134,
    name: "account-wechat-pay___en"
  }, {
    path: "/en/campaigns/create",
    component: _f1223faa,
    name: "campaigns-create___en"
  }, {
    path: "/en/common/payment",
    component: _757c2b68,
    name: "common-payment___en"
  }, {
    path: "/en/files/preview",
    component: _d0768f86,
    name: "files-preview___en"
  }, {
    path: "/en/manageAudience/index-old",
    component: _8fc81cae,
    name: "manageAudience-index-old___en"
  }, {
    path: "/en/manageEvent/copy",
    component: _b0b852dc,
    name: "manageEvent-copy___en"
  }, {
    path: "/en/manageEvent/indexV1",
    component: _092d2c40,
    name: "manageEvent-indexV1___en"
  }, {
    path: "/en/offers/copy",
    component: _7cedabba,
    name: "offers-copy___en"
  }, {
    path: "/en/offers/create",
    component: _81bfaafe,
    name: "offers-create___en"
  }, {
    path: "/en/offers/detail",
    component: _2fbeef56,
    name: "offers-detail___en"
  }, {
    path: "/en/offers/edit",
    component: _0ad9d062,
    name: "offers-edit___en"
  }, {
    path: "/en/offers/set-tracking",
    component: _66a64487,
    name: "offers-set-tracking___en"
  }, {
    path: "/en/reports/cohort",
    component: _db3638f0,
    name: "reports-cohort___en"
  }, {
    path: "/en/reports/creative",
    component: _56790782,
    name: "reports-creative___en"
  }, {
    path: "/en/reports/dco",
    component: _26ca30cd,
    name: "reports-dco___en"
  }, {
    path: "/en/reports/event",
    component: _42f7a557,
    name: "reports-event___en"
  }, {
    path: "/en/reports/pixel",
    component: _38c32f43,
    name: "reports-pixel___en"
  }, {
    path: "/en/reports/skan",
    component: _5b60b6d8,
    name: "reports-skan___en"
  }, {
    path: "/en/settings/mediaPostback",
    component: _41674ee5,
    name: "settings-mediaPostback___en"
  }, {
    path: "/ja/account/add-funds",
    component: _050afa4d,
    name: "account-add-funds___ja"
  }, {
    path: "/ja/account/attribution-setting",
    component: _13773b6d,
    name: "account-attribution-setting___ja"
  }, {
    path: "/ja/account/billing-management",
    component: _152749ba,
    name: "account-billing-management___ja"
  }, {
    path: "/ja/account/change-password",
    component: _a9b041fa,
    name: "account-change-password___ja"
  }, {
    path: "/ja/account/complete-account",
    component: _60761484,
    name: "account-complete-account___ja"
  }, {
    path: "/ja/account/operation-log",
    component: _27a3d2ee,
    name: "account-operation-log___ja"
  }, {
    path: "/ja/account/reset-password",
    component: _7e86ee84,
    name: "account-reset-password___ja"
  }, {
    path: "/ja/account/target-app",
    component: _32be97ca,
    name: "account-target-app___ja"
  }, {
    path: "/ja/account/user-management",
    component: _84456820,
    name: "account-user-management___ja"
  }, {
    path: "/ja/account/wechat-pay",
    component: _39c43134,
    name: "account-wechat-pay___ja"
  }, {
    path: "/ja/campaigns/create",
    component: _f1223faa,
    name: "campaigns-create___ja"
  }, {
    path: "/ja/common/payment",
    component: _757c2b68,
    name: "common-payment___ja"
  }, {
    path: "/ja/files/preview",
    component: _d0768f86,
    name: "files-preview___ja"
  }, {
    path: "/ja/manageAudience/index-old",
    component: _8fc81cae,
    name: "manageAudience-index-old___ja"
  }, {
    path: "/ja/manageEvent/copy",
    component: _b0b852dc,
    name: "manageEvent-copy___ja"
  }, {
    path: "/ja/manageEvent/indexV1",
    component: _092d2c40,
    name: "manageEvent-indexV1___ja"
  }, {
    path: "/ja/offers/copy",
    component: _7cedabba,
    name: "offers-copy___ja"
  }, {
    path: "/ja/offers/create",
    component: _81bfaafe,
    name: "offers-create___ja"
  }, {
    path: "/ja/offers/detail",
    component: _2fbeef56,
    name: "offers-detail___ja"
  }, {
    path: "/ja/offers/edit",
    component: _0ad9d062,
    name: "offers-edit___ja"
  }, {
    path: "/ja/offers/set-tracking",
    component: _66a64487,
    name: "offers-set-tracking___ja"
  }, {
    path: "/ja/reports/cohort",
    component: _db3638f0,
    name: "reports-cohort___ja"
  }, {
    path: "/ja/reports/creative",
    component: _56790782,
    name: "reports-creative___ja"
  }, {
    path: "/ja/reports/dco",
    component: _26ca30cd,
    name: "reports-dco___ja"
  }, {
    path: "/ja/reports/event",
    component: _42f7a557,
    name: "reports-event___ja"
  }, {
    path: "/ja/reports/pixel",
    component: _38c32f43,
    name: "reports-pixel___ja"
  }, {
    path: "/ja/reports/skan",
    component: _5b60b6d8,
    name: "reports-skan___ja"
  }, {
    path: "/ja/settings/mediaPostback",
    component: _41674ee5,
    name: "settings-mediaPostback___ja"
  }, {
    path: "/settings/mediaPostback/create",
    component: _1336d879,
    name: "settings-mediaPostback-create___en___default"
  }, {
    path: "/settings/mediaPostback/edit",
    component: _84263872,
    name: "settings-mediaPostback-edit___en___default"
  }, {
    path: "/cn/settings/mediaPostback/create",
    component: _1336d879,
    name: "settings-mediaPostback-create___cn"
  }, {
    path: "/cn/settings/mediaPostback/edit",
    component: _84263872,
    name: "settings-mediaPostback-edit___cn"
  }, {
    path: "/en/settings/mediaPostback/create",
    component: _1336d879,
    name: "settings-mediaPostback-create___en"
  }, {
    path: "/en/settings/mediaPostback/edit",
    component: _84263872,
    name: "settings-mediaPostback-edit___en"
  }, {
    path: "/ja/settings/mediaPostback/create",
    component: _1336d879,
    name: "settings-mediaPostback-create___ja"
  }, {
    path: "/ja/settings/mediaPostback/edit",
    component: _84263872,
    name: "settings-mediaPostback-edit___ja"
  }, {
    path: "/",
    component: _739390df,
    name: "index___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
